<template>
  <div class="privacy-policy">
    <h1>Политика обработки и защиты персональных данных</h1>

    <section>
      <h2>1. Общие положения</h2>
      <p>
        Настоящая политика обработки и защиты персональных данных составлена в соответствии с требованиями Федерального
        закона от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры
        по обеспечению безопасности персональных данных, предпринимаемые индивидуальным предпринимателем Меркурьевой
        Марией Викторовной (далее — Оператор, ИП).
      </p>
      <p>
        1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод
        человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность
        частной жизни, личную и семейную тайну.
      </p>
      <p>
        1.2. Настоящая Политика определяет принципы, порядок и условия обработки и защиты персональных данных и
        действует в отношении всех персональных данных (далее по тексту – «Данные», «ПД»), которые ИП может получить от
        субъекта персональных данных, являющегося стороной по гражданско-правовому договору, настоящая политика
        Оператора также применяется в отношении всей информации, которую Оператор может получить о посетителях веб-сайта
        <a href="http://an-merkuriy.ru/">http://an-merkuriy.ru/</a>.
      </p>
    </section>

    <section>
      <h2>2. Основные понятия, используемые в Политике</h2>
      <p>
        2.1. Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств
        вычислительной техники;
      </p>
      <p>
        2.2. Блокирование персональных данных — временное прекращение обработки персональных данных (за исключением
        случаев, если обработка необходима для уточнения персональных данных);
      </p>
      <p>
        2.3. Веб-сайт — совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных,
        обеспечивающих их доступность в сети интернет по сетевому адресу <a href="http://an-merkuriy.ru/">http://an-merkuriy.ru/</a>;
      </p>
      <p>
        2.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных,
        и обеспечивающих их обработку информационных технологий и технических средств;
      </p>
      <p>
        2.5. Обезличивание персональных данных — действия, в результате которых невозможно определить без использования
        дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту
        персональных данных;
      </p>
      <p>
        2.6. Обработка персональных данных — любое действие (операция) или совокупность действий (операций), совершаемых
        с использованием средств автоматизации или без использования таких средств с персональными данными, включая
        сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение,
        использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление,
        уничтожение персональных данных;
      </p>
      <p>
        2.7. Оператор — государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или
        совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также
        определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия
        (операции), совершаемые с персональными данными;
      </p>
      <p>
        2.8. Сведениями, составляющими персональные данные (далее по тексту – «персональные данные», «ПД»), является
        любая информация, относящаяся прямо или косвенно определенному или определяемому физическому лицу (субъекту
        персональных данных);
      </p>
      <p>
        2.9. Пользователь — любой посетитель веб-сайта <a href="http://an-merkuriy.ru/">http://an-merkuriy.ru/</a>;
      </p>
      <p>
        2.10. Предоставление персональных данных — действия, направленные на раскрытие персональных данных определенному
        лицу или определенному кругу лиц;
      </p>
      <p>
        2.11. Распространение персональных данных — любые действия, направленные на раскрытие персональных данных
        неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными
        неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации,
        размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным
        каким-либо иным способом;
      </p>
      <p>
        2.12. Трансграничная передача персональных данных — передача персональных данных на территорию иностранного
        государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу;
      </p>
      <p>
        2.13. Уничтожение персональных данных — любые действия, в результате которых персональные данные уничтожаются
        безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе
        персональных данных и (или) уничтожаются материальные носители персональных данных.
      </p>
    </section>

    <section>
      <h2>3. Оператор может обрабатывать следующие персональные данные Пользователя</h2>
      <p>
        3.1. На сайте происходит сбор и обработка обезличенных данных о посетителях в виде файлов «cookie».
      </p>
      <p>
        3.2. Указанные в п. 3.1. данные далее по тексту Политики объединены общим понятием Персональные данные.
      </p>
    </section>

    <section>
      <h2>4. Цели обработки персональных данных, сбора файлов куки</h2>
      <p>
        4.1. Для сохранения информации о Пользователе на время использования им Сайта;
      </p>
      <p>
        4.2. Для идентификации (распознавание браузера и/или устройства каждый раз, когда им осуществляется вход на
        Сайт, сохранение настроек экрана и браузера);
      </p>
      <p>
        4.3. Для работы отдельных разделов Сайта;
      </p>
      <p>
        4.4. Для удобства использования Сайта и навигации по нему;
      </p>
      <p>
        4.5. Для улучшения взаимодействия Сайта и Пользователей;
      </p>
      <p>
        4.6. Для повышения качества обслуживания и обеспечения максимального удобства и комфорта Пользователей при
        использовании Сайта.
      </p>
      <p>
        4.7. Цель обработки: повышение удобства пользования сайтом.
      </p>
    </section>

    <section>
      <h2>5. Виды собираемой информации</h2>
      <p>
        Оператор не использует Файлы куки для идентификации Пользователя, а исключительно для удобства использования
        Пользователем Сайта. Через Файлы собирается следующая информация о Пользователе:
      </p>
      <p>
        5.1. IP адрес, тип браузера и устройства, с которого выполняется вход на Сайт;
      </p>
      <p>
        5.2. Операционная система и данные об Интернет провайдере;
      </p>
      <p>
        5.3. Информация о стране, из которой выполняется вход;
      </p>
      <p>
        5.4. Дата и время посещения Сайта, а также возможное количество совершенных кликов Пользователем.
      </p>
    </section>

    <section>
      <h2>6. Удаление/отключение работы Файлов куки</h2>
      <p>
        6.1. Оставаясь на Сайте Пользователь подтверждает свое согласие на использование Файлов куки.
      </p>
      <p>
        6.2. Если Пользователь не согласен с тем, чтобы Сайт использовал Файлы куки, то Пользователь должен
        соответствующим образом установить настройки своего браузера или не использовать Сайт.
      </p>
      <p>
        6.3. Каждый Пользователь в любой момент может отключить работу Файлов куки на устройстве, с которого совершается
        вход на Сайт, и/или удалить уже загруженные ранее Файлы куки на устройство. Если Пользователь не желает
        отключать работу Файлов куки и/или удалять ранее загруженные Файлы куки, никакие дополнительные действия не
        требуются от Пользователя в данном случае.
      </p>
    </section>

    <section>
      <h2>7. Порядок сбора, хранения, передачи и других видов обработки персональных данных</h2>
      <p>
        Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых,
        организационных и технических мер, необходимых для выполнения в полном объеме требований действующего
        законодательства в области защиты персональных данных.
      </p>
      <p>
        7.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к
        персональным данным неуполномоченных лиц.
      </p>
      <p>
        7.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за
        исключением случаев, связанных с исполнением действующего законодательства.
      </p>
      <p>
        7.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно,
        путем направления Оператору уведомление на адрес электронной почты Оператора
        <a href="mailto:an.merkuriy@yandex.ru">an.merkuriy@yandex.ru</a> с пометкой «Актуализация персональных данных».
      </p>
      <p>
        7.4. Срок обработки персональных данных является – до момента отзыва пользователем согласия и изменения
        пользователем настроек браузера. Пользователь может в любой момент отозвать свое согласие на обработку
        персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора
        <a href="mailto:an.merkuriy@yandex.ru">an.merkuriy@yandex.ru</a> с пометкой «Отзыв согласия на обработку
        персональных данных».
      </p>
    </section>

    <section>
      <h2>8. Трансграничная передача персональных данных</h2>
      <p>
        8.1. Оператор не осуществляет трансграничную передачу персональных данных.
      </p>
    </section>

    <section>
      <h2>9. Заключительные положения</h2>
      <p>
        9.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его
        персональных данных, обратившись к Оператору с помощью электронной почты <a href="mailto:an.merkuriy@yandex.ru">an.merkuriy@yandex.ru</a>.
      </p>
      <p>
        9.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором.
        Политика действует бессрочно до замены ее новой версией.
      </p>
      <p>
        9.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу
        <a href="http://an-merkuriy.ru/privacy-policy">http://an-merkuriy.ru/privacy-policy</a>.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
  .privacy-policy {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
    line-height: 1.6;
  }
  h1 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  p {
    margin-bottom: 10px;
  }
  a {
    color: #007bff;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  /* Адаптивность */
  @media (max-width: 768px) {
    .privacy-policy {
      padding: 15px;
    }
    h1 {
      font-size: 20px;
    }
    h2 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
  }
  @media (max-width: 480px) {
    .privacy-policy {
      padding: 10px;
    }
    h1 {
      font-size: 18px;
    }
    h2 {
      font-size: 16px;
    }
    p {
      font-size: 12px;
    }
  }
</style>
